import React, { useState } from 'react';
import moment from 'moment';
import Ipms from '../../images/ipms.svg';
import './EngineConfirmationUpdate.css';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import LineDropdownSelector from '../LineDropdownSelector/LineDropdownSelector';
import { Link } from 'react-router-dom';
import EngineConfirmationTable from './EngineConfirmationTable';
import Select from 'react-select';
import styles from '../LineDropdownSelector/LineDropdownSelector.module.css';
import clsx from 'clsx';

const EngineConfirmationUpdate = () => {
  const [plant] = usePlantAndLinesStore().plantState;
  const [line] = usePlantAndLinesStore().lineState;
  const [lineOptions] = usePlantAndLinesStore().lineOptions;

  const [secondLine, setSecondLine] = useState(null);

  const customStyles = {
    control: provided => ({
      ...provided,
      width: 120,
      minWidth: 120,
      height: 30,
      minHeight: 30,
      fontSize: '12px',
      background: 'none',
      paddingTop: 0,
      paddingBottom: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      width: 120,
      minWidth: 120,
      height: 30,
      minHeight: 30,
      fontSize: '12px',
    }),
    dropdownIndicator: provided => ({
      ...provided,
      width: 30,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    indicatorSeparator: () => ({ display: 'none' }),
    singleValue: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    input: (provided) => ({
      ...provided,
      color: '#fff',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#aaa',
    }),
  };

  return (
    <div>
      <div>
        <table
          width="98%"
          border="0"
          align="center"
          cellpadding="0"
          cellspacing="0"
          className="display_table"
        >
          <tr>
            <td>
              <table width="100%" border="0">
                <tr>
                  <td
                    width="24%"
                    height="72"
                    align="left"
                    valign="middle"
                    className="liveUpdate"
                  >
                    <span className="thead">LIVE UPDATE</span>
                    <strong className="date">
                      {moment().format('DD MMMM').toUpperCase()}{' '}
                      {moment().format('YYYY')}
                    </strong>{' '}
                  </td>
                  <td
                    width="36%"
                    align="left"
                    valign="middle"
                    className="title"
                  >
                    <span className="thead">Engine Confirmation Broadcast</span>
                    <strong>Chassis Dropping Sequence</strong>
                  </td>
                  <td width="20%" align="left" valign="middle">
                    <div className="line-selectors-container">
                      <div style={{ marginRight: '15px' }}>
                        <span className="selectLine" style={{ display: 'block', marginBottom: '2px', fontSize: '10px', color: '#ccc' }}>Select Line 1</span>
                        <LineDropdownSelector isDarkStyle={true} />
                      </div>
                      <div>
                        <span className="selectLine" style={{ display: 'block', marginBottom: '2px', fontSize: '10px', color: '#ccc' }}>Select Line 2</span>
                        <Select
                          value={secondLine}
                          onChange={setSecondLine}
                          options={lineOptions}
                          styles={customStyles}
                          className={clsx(styles.dropdown, styles.dropdownDark)}
                          classNamePrefix="select-line"
                          isClearable={true}
                          placeholder="None"
                        />
                      </div>
                    </div>
                  </td>
                  <td
                    width="20%"
                    align="right"
                    valign="middle"
                    className="logo"
                  >
                    <Link to="/">
                      <img
                        src={Ipms}
                        alt="IPMS"
                        width="80%"
                        className="logo_img"
                      />
                    </Link>
                  </td>
                </tr>
              </table>

              <div className={secondLine ? "split-view-container" : ""}>
                <div className={secondLine ? "split-view-item" : ""}>
                  <EngineConfirmationTable
                    plant={plant}
                    line={line}
                    isSplitView={!!secondLine}
                  />
                </div>
                {secondLine && (
                  <div className="split-view-item">
                    <EngineConfirmationTable
                      plant={plant}
                      line={secondLine}
                      isSplitView={true}
                    />
                  </div>
                )}
              </div>

            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default EngineConfirmationUpdate;
